(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('reportService', reportService);

    function reportService($http, $q, baseUrl, portalIdentifier, tokenService, portalGroupService) {
        baseUrl = baseUrl || "";

        return {
            getDepartmentReport: getDepartmentReport,
            getAdministratorReport: getAdministratorReport
        };

        function getDepartmentReport(params) {
            return tokenService.getToken()
                .then(() => $q.all([
                    $http.get(baseUrl + '/api/6.0/reports/departments/' + portalIdentifier, {
                        params: params
                    }),
                    portalGroupService.getGroups(true)
                ]))
                .then(responses => {
                    var reportResponse = responses[0].data;
                    var groups = responses[1];

                    reportResponse.forEach(r => {
                        var department = groups.find(g => g.id.toLowerCase() === r.departmentId.toLowerCase());
                        if (department) {
                            r.departmentName = department.name;
                        } else {
                            r.departmentName = r.departmentId.toLowerCase();
                        }
                    });
                    return reportResponse;
                }, errorResponse => $q.reject(errorResponse.data));
        }

        function getAdministratorReport(params) {
            return tokenService.getToken()
                .then(() => $http.get(baseUrl + "/api/6.0/reports/skills/" + portalIdentifier, {
                    params: params
                }))
                .then(response => {
                    if (typeof response.data === 'object') {
                        return response.data;
                    } else {
                        return $q.reject(response.data);
                    }
                });
        }
    }
})();
